<template>
  <section :class="$style.fee">
    <sub-title :title="'入館料'"></sub-title>
    <div :id="$style.fee_grid">
      <div :id="$style.fee_detail">
        <ul>
          <li>
            一般
            <span :class="$style.border"></span>&yen;400（税込）
          </li>
          <li>
            小・中学生
            <span :class="$style.border"></span>&yen;100（税込）
          </li>
          <li>
            園児・幼児
            <span :class="$style.border"></span>無料
          </li>
        </ul>
      </div>
      <div :id="$style.fee_group" :class="$style.margin">
        <div :class="$style.middle_title">団体割引</div>
        <div>10名様より10名ごとに1名様分割引とさせていただきます。</div>
        <table>
          <tr>
            <td>10〜19名・・・・・400円引（税込み）</td>
          </tr>
          <tr>
            <td>20〜29名・・・・・800円引（税込み）</td>
          </tr>
          <tr>
            <td>30〜39名・・・・・1200円引（税込み）</td>
          </tr>
          <tr>
            <td>40〜49名・・・・・1600円引（税込み）</td>
          </tr>
        </table>
      </div>
      <div :id="$style.fee_handi" :class="$style.margin">
        <div :class="$style.middle_title">障害者割引</div>
        <div>身体障害者手帳・療育手帳・精神障害者手帳をお持ちの方は、手帳（コピー可）をご提示いただきましたら、介助者（1名）の方とともに、入場料を半額とさせていただきます。</div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SubTitle from "@/components/atoms/SubTitle.vue";

export default Vue.extend({
  name: "FeeVisual",
  components: {
    SubTitle
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .fee {
    #fee_grid {
      display: grid;
      grid-template-rows: 150px 1fr 150px;
      #fee_detail {
        grid-row: 1/2;
        font-size: 17px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 15px;
        ul {
          list-style: none;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            .border {
              width: 18px;
              border: 1px solid #000;
              margin: 0px 10px;
            }
          }
          li:first-child {
            .border {
              width: 63px;
            }
          }
        }
      }
      .margin {
        // margin: 0px 10px;
      }
      .middle_title {
        font-size: 19px;
        color: #38761d;
        margin-bottom: 5px;
      }
      #fee_group {
        grid-row: 2/3;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        table {
          width: 250px;
          margin: auto;
          tr {
            border: 1px solid #000;
            td {
              padding: 2px 6px;
            }
          }
        }
      }
      #fee_handi {
        grid-row: 3/4;
        margin-top: 20px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .fee {
    #fee_grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 140px 1fr;
      #fee_detail {
        grid-row: 1/2;
        grid-column: 1/3;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 15px;
        ul {
          list-style: none;
          li {
            display: flex;
            align-items: center;
            .border {
              width: 60px;
              border: 1px solid #000;
              margin: 0px 10px;
            }
          }
          li:first-child {
            .border {
              width: 113px;
            }
          }
        }
      }
      .margin {
        margin: 0px 33px;
      }
      .middle_title {
        font-size: 19px;
        color: #38761d;
        margin-bottom: 5px;
      }
      #fee_group {
        grid-row: 2/3;
        grid-column: 1/2;
        table tr {
          border: 1px solid #000;
          td {
            padding: 2px 6px;
          }
        }
      }
      #fee_handi {
        grid-row: 2/3;
        grid-column: 2/3;
      }
    }
  }
}
</style>

